import { motion } from 'framer-motion';
import { ArrowRight, Cpu } from 'lucide-react';

const inputs = ['Government Need', 'Prime Contractor Strategy', 'Technology Platforms'];
const outputs = ['Delivered Programs', 'Operational Efficiency', 'Measurable Outcomes'];

export default function OperatingModel() {
  return (
    <section
      id="operating-model"
      data-testid="operating-model-section"
      className="py-24 lg:py-32 bg-[#0A0A0A] relative overflow-hidden"
    >
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at 50% 50%, rgba(184,16,46,0.04) 0%, transparent 60%)'
      }} />

      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
            How We Operate
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight">
            Our Operating Model
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="grid md:grid-cols-3 gap-8 items-center"
        >
          {/* Inputs */}
          <div className="space-y-3">
            <p className="font-body text-xs tracking-[0.2em] uppercase text-[#737373] mb-4 text-center md:text-left">
              Inputs
            </p>
            {inputs.map((item, i) => (
              <div
                key={i}
                data-testid={`input-item-${i}`}
                className="p-4 bg-[#141414] border border-[#2A2A2A] rounded-lg text-center md:text-left"
              >
                <p className="font-body text-sm text-[#A3A3A3]">{item}</p>
              </div>
            ))}
          </div>

          {/* Center Engine */}
          <div className="flex flex-col items-center gap-4">
            <div className="hidden md:block">
              <ArrowRight className="text-[#B8102E] h-5 w-5 animate-pulse" />
            </div>
            <div
              data-testid="execution-engine"
              className="relative w-full max-w-[240px] p-8 bg-[#0A0A0A] border-2 border-[#B8102E] rounded-xl text-center shadow-[0_0_40px_rgba(184,16,46,0.12)]"
            >
              <Cpu className="h-10 w-10 text-[#B8102E] mx-auto mb-3" />
              <p className="font-heading text-lg font-bold text-white">Cole Utilities</p>
              <p className="font-body text-xs text-[#B8102E] tracking-[0.15em] uppercase mt-1">
                Execution Layer
              </p>
            </div>
            <div className="hidden md:block">
              <ArrowRight className="text-[#B8102E] h-5 w-5 animate-pulse" />
            </div>
          </div>

          {/* Outputs */}
          <div className="space-y-3">
            <p className="font-body text-xs tracking-[0.2em] uppercase text-[#737373] mb-4 text-center md:text-left">
              Outputs
            </p>
            {outputs.map((item, i) => (
              <div
                key={i}
                data-testid={`output-item-${i}`}
                className="p-4 bg-[#141414] border border-[#B8102E]/20 rounded-lg text-center md:text-left"
              >
                <p className="font-body text-sm text-white font-medium">{item}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
